import {
    forwardRef,
    ForwardRefRenderFunction,
    SelectHTMLAttributes,
} from "react";
import { FieldError } from "react-hook-form";
import { Product } from "../../domain/Product";

import {
    FormControl,
    FormErrorMessage,
    FormLabel,
    Select as FormSelect,
} from "./styles";

interface ProductSelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
    id: string;
    label?: string;
    error?: string | FieldError;
    showErrorMessage?: boolean;
    labelTextColor?: string;
    backgroundColor?: string;
    borderColor?: string;
    focusBorderColor?: string;
    textColor?: string;
    products: Product[];
    placeholder?: string;
}

const ProductSelectBase: ForwardRefRenderFunction<HTMLSelectElement, ProductSelectProps> = (
    {
        id,
        label,
        error,
        showErrorMessage = true,
        labelTextColor,
        backgroundColor,
        borderColor,
        focusBorderColor,
        textColor,
        products,
        placeholder = "Selecione um produto",
        ...rest
    },
    ref
) => {
    return (
        <FormControl isInvalid={!!error}>
            {!!label && <FormLabel htmlFor={id} $textColor={labelTextColor}>{label}</FormLabel>}

            <FormSelect
                id={id}
                ref={ref}
                aria-invalid={!!error && showErrorMessage ? "true" : "false"}
                $backgroundColor={backgroundColor}
                $borderColor={borderColor}
                $focusBorderColor={focusBorderColor}
                $textColor={textColor}
                {...rest}
            >
                <option value="" disabled>
                    {placeholder}
                </option>
                {products.map((product) => (
                    <option key={product.id} value={product.id}>
                        {product.name}
                    </option>
                ))}
            </FormSelect>

            {!!error && showErrorMessage && (
                <FormErrorMessage data-testid="error-message">
                    {typeof error === 'string' ? error : error.message}
                </FormErrorMessage>
            )}
        </FormControl>
    );
};

export const ProductSelect = forwardRef(ProductSelectBase);
